import React from 'react';
import { ArrowRight } from 'lucide-react';
export function UsefulLinks() {
  const links = [{
    text: 'Proefpakket bestellen',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/284458/proefpakket_hond_400g_1_set_met_verschillende_soorten_natvoer_vlokken_en_testpakketten_?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Power-Darm voor darmherstel',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/398758/powerdarm_60g_1_stuk_?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Standaard Omschakelpakket',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/165810?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Bio Rundvlees',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/40683/rydog_vitaal_menu_biologisch_rundvlees_400g_6_stuk_?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Gans',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/423439/bio_gans_met_geluk_400g_6_stuk_?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Gezonde Snacks',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/articles/62193?new_client_country=NL&category=62183&refconsultant=487050'
  }, {
    text: 'Volledig Natvoer Assortiment',
    url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/articles/62183?new_client_country=NL&category=62183&refconsultant=487050'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-238">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
        <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-240">
          Handige Links
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto" data-id="element-241">
          {links.map((link, index) => <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-700 hover:text-[#4DBFB8] transition-colors p-3 bg-white rounded-lg shadow-sm hover:shadow-md" data-id="element-242">
              <ArrowRight className="w-4 h-4 text-[#4DBFB8]" data-id="element-243" />
              <span className="font-medium" data-id="element-244">{link.text}</span>
            </a>)}
        </div>

        <div className="text-center mt-10" data-id="element-245">
          <p className="inline-block bg-[#4DBFB8] text-white px-6 py-2 rounded-full font-bold shadow-md" data-id="element-246">
            Vergeet niet: gebruik code "stresslessdogs" voor 10% korting!
          </p>
        </div>
      </div>
    </section>;
}